<template>
  <!-- 左右图文组件 -->
  <section class="img-desc" id="feature">
    <div class="w-12r m-a">
      <h2 v-if="mainTitle" class="ta-c c-333">{{ $t(mainTitle) }}</h2>
      <div
        class="d-f"
        :class="isRe && index % 2 === isReverse ? 'fd-r' : '' + customStyle"
        v-for="(item, index) in imgDescData"
        :key="index"
      >
        <div class="img-box">
          <video
            v-if="item.videoSrc"
            class="lazy-video"
            width="100%"
            height="100%"
            x5-playsinline
            x5-video-player-type="h5"
            x-webkit-airplay="allow"
            playsinline
            webkit-playsinline
            muted
            loop
            autoplay
            preload="none"
            :poster="item.imgSrc"
            :src="item.videoSrc"
            data-src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b275976f387702305400292769/3rnsZJiIQa8A.mp4"
          ></video>
          <img v-else width="100%" height="100%" v-lazy="item.imgSrc" :alt="item.title" srcset="" />
        </div>
        <div class="text d-f fd-c jc-c">
          <a :href="item.link" :class="item.link ? 'c-p' : 'c-d'">
            <template v-if="$slots.default"><slot></slot></template>
            <template v-else>
              <strong class="c-333 d-b reveal">{{ $t(item.title) }}</strong>
              <div class="reveal desc c-666" v-html="$t(item.desc)"></div>
              <div v-if="item.icon" class="icon">
                <svg-icon :icon-class="item.icon" />
              </div>
            </template>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      imgDescData: {
        type: Array,
        default: () => []
      },
      customStyle: {
        type: String,
        default: ''
      },
      mainTitle: {
        type: String,
        default: ''
      },
      // 0 第一个为 左文字 右视频或图片
      isReverse: {
        type: [Number, String],
        default: 0
      },
      isRe: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {}
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  /* img-desc */
  .img-desc {
    margin-bottom: 1.6rem;
  }
  .img-desc h2 {
    margin-bottom: 0.32rem;
    font-size: 0.48rem;
  }
  .img-desc .img-box {
    flex: 0 0 auto;
    width: 6rem;
    height: 3.38rem;
  }
  .img-desc .text {
    flex: 0 0 auto;
    width: 6rem;
    position: relative;
    background-color: rgba(250, 250, 250, 1);
  }
  .img-desc .text strong {
    margin: 0 0.48rem 0.24rem 0.48rem;
    font-size: 0.28rem;
    font-weight: 500;
  }
  .img-desc .text strong,
  .img-desc .text .desc {
    margin-left: 0.48rem;
    margin-right: 0.48rem;
  }
  .img-desc .text .icon {
    width: 0.36rem;
    height: 0.36rem;
    margin-top: 0.48rem;
    margin-left: 0.48rem;
    transition: transform 0.3s linear;
  }
  .img-desc .text a:hover .icon {
    transform: translateX(10px);
  }
  // .img-desc .strong-title {
  //   margin-bottom: 0 0.48rem 0.24rem 0.48rem;
  // }
</style>
